import * as Yup from "yup";
import { emailRegex, spaceRegExp } from "utils/regex";

export const email = Yup.string()
  .email("Email does not exist.")
  .required("Email is required")
  .matches(emailRegex, "Email is invalid");

export const Name = Yup.string().required("Name is required");

export const Password = Yup.string()
  .min(6, "Password should be at least 6 characters long")
  .matches(spaceRegExp, "Password cannot contain spaces")
  .max(50, "Password should not contain more than 50 characters")
  .required("Password is required");

export const confirmPassword = Yup.string()
  .oneOf(
    [Yup.ref("password")],
    "New password and confirm password do not match!",
  )
  .matches(spaceRegExp, "Password cannot contain spaces")
  .required("Please confirm Your password");

export const oldPassword = Yup.string()
  .min(6, "Current password should be at least 6 characters long")
  .matches(spaceRegExp, "Old password cannot contain spaces")
  .max(50, "Current password should not contain more than 50 characters")
  .required("Please enter current password");

export const newPassword = Yup.string()
  .min(6, "New password should be at least 6 characters long")
  .required("Please enter new password")
  .notOneOf(
    [Yup.ref("oldPassword"), null],
    "Current password and new password can not be the same",
  )
  .matches(spaceRegExp, "New password cannot contain spaces")
  .max(50, "New password should not contain more than 50 characters");

export const confirmNewPassword = Yup.string()
  .oneOf(
    [Yup.ref("newPassword"), null],
    "New password and confirm password must be same",
  )
  .required("Please enter confirm password");

export const Title = Yup.string().required("Title is required");

export const Content = Yup.string().required("Content is required");

export const Type = Yup.string().required("Type is required");
export const Role = Yup.string().required("Select a role");

export const Code = Yup.string().required("Code is required");

export const announcementTitle = Yup.string()
  .required("Announcement title is required")
  .min(3, "Announcement title must be 3 characters long");

export const announcementContent = Yup.string()
  .required("Announcement Content is required")
  .min(3, "Announcement Content must be 3 characters long");

export const announcementUsers = Yup.array().when(
  "announcementType",
  (announcementType, schema) => {
    return announcementType === "custom"
      ? schema
          .min(1, "Please select at least one user")
          .required("User selection is required")
      : schema.notRequired();
  },
);
